/**
 * External dependencies
 */
import { Reducer } from 'redux';

/**
 * Internal dependencies
 */
import { setEventResponsesLoading } from '@/store/actions';
import initialState from '../../initialState';
import isAction from '../../isAction';

const loading: Reducer<boolean> = (
	state = initialState.currentEvent.loading,
	action
) => (isAction(action, setEventResponsesLoading) ? action.payload : state);

export default loading;
